import LeTopology from './src';
import '../static/styles/_le_topology.scss';

// 为组件提供 install 安装方法，供按需引入
LeTopology.install = function(Vue) {
  Vue.component(LeTopology.name, LeTopology);
};

// 导出组件
export default LeTopology;
